import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StripeConnectOnboardingPage } from './stripe-connect-onboarding.page';

const routes: Routes = [
  {
    path: '',
    component: StripeConnectOnboardingPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StripeConnectOnboardingPageRoutingModule {} 